import {
  createBrowserRouter,
  RouterProvider,
  ScrollRestoration,
} from "react-router-dom";
import Login from "./pages/Login";
import Layout from "./pages/Layout";
import GenerateReport from "./pages/GenerateReport";
import Snapshot from "./pages/Snapshot";
import AuthProvider from "./utils/auth";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthProvider>
        <ScrollRestoration />
        <Layout />
      </AuthProvider>
    ),
    children: [
      { index: true, element: <GenerateReport /> },
      { path: "snapshot", element: <Snapshot /> },
    ],
  },
  {
    path: "/login",
    element: (
      <AuthProvider>
        <ScrollRestoration />
        <Login />
      </AuthProvider>
    ),
  },
]);

const App = () => <RouterProvider router={router} />;

export default App;
